export const API_URL = 'https://serv.mesds.ru/api';
export const WS_URL = 'wss://serv.mesds.ru/ws';
export const LIVEKIT_URL = 'wss://serv.mesds.ru/livekit/';
export const MAX_RECORDING_TIME = 180;
export const MAX_RECONNECT_ATTEMPTS = 10;
export const TIMEOUT_UPLOAD = 10*60*1000; //10 min
export const MAX_FILES_COUNT = 10;
export const MAX_AVATAR_SIZE = 5 * 1024 * 1024;

export const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
export const IS_STANDALONE = window.matchMedia('(display-mode: standalone)').matches 
                    || window.navigator.standalone === true;
export const IS_IOS_WITHOUT_PWA = IS_IOS && !IS_STANDALONE;
export const SUPPORTS_PUSH = 'PushManager' in window && 'serviceWorker' in navigator;

export const COLORS = {
    primary: '#2a4a6a',
    primaryHover: '#3a5a7a',
    accent: '#4a9eff',
    danger: '#dc3545',
    dangerHover: '#c82333',
};
// Разрешённые расширения для аватаров
export const ALLOWED_AVATAR_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
export const ALLOWED_AVATAR_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/svg+xml'
];